// extracted by mini-css-extract-plugin
export default {"hue":"MymbP","saturation":"Kwe1K","huePointer":"HGAbi","saturationPointer":"Brggo"};